import { createSelector } from '@reduxjs/toolkit'
import { sortCheckpointableEntities } from '../../../helpers/sortCheckpointableEntities'
import {
  getCompletedAssignmentsIds,
  getCompletedPhaseItemsIds,
} from '../../getters/entities/approvalIds'
import { NormalizedApproval } from '../types'
import { selectNormalizedApprovals } from './normalizedApprovals'

const selectCompletedAssignmentIds = createSelector(
  [getCompletedAssignmentsIds],
  (completedAssignmentIds) => completedAssignmentIds || []
)

const selectCompletedPhaseItemIds = createSelector(
  [getCompletedPhaseItemsIds],
  (completedPhaseItemIds) => completedPhaseItemIds || []
)

export const selectCompletedApprovals = createSelector(
  [
    selectNormalizedApprovals,
    selectCompletedAssignmentIds,
    selectCompletedPhaseItemIds,
  ],
  (normalizedApprovals, completedAssignmentIds, completedPhaseItemIds) => {
    const phaseItems = completedPhaseItemIds.map((id) =>
      normalizedApprovals.find(
        (approval) => approval.id === id && approval.entityType === 'phase_item'
      )
    )

    const assignments = completedAssignmentIds.map((id) =>
      normalizedApprovals.find(
        (approval) => approval.id === id && approval.entityType === 'assignment'
      )
    )

    return sortCheckpointableEntities(
      [...phaseItems, ...assignments].filter(
        (approval): approval is NormalizedApproval => approval !== undefined
      )
    )
  }
)
